<div class="transaction-fee">
    <button
        class="btn btn__fee"
        [class.btn__fee--active]="selectedFee === 'safe'"
        (click)="changeFee('safe')"
    >
        <svg
            class="icon__fee"
            viewBox="0 0 32 32"
            fill="var(--icon-color)"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M21.4687 14.6741C20.7608 12.5047 18.6664 8.72293 12.7373 9.01609C6.71966 9.30925 5.15626 13.6187 4.74329 15.964C9.07951 16.7262 17.6045 17.7523 21.4687 14.6741Z"
            />
            <path
                d="M29.5218 12.9153C28.3124 11.0684 25.1266 9.57329 24.7726 11.8893C24.5071 13.7069 23.5926 14.7916 22.9732 15.4072C20.6723 17.6059 16.7196 18.2802 12.8848 18.2802C7.92913 18.2802 3.12093 17.1955 2 16.9316C2.41297 18.9251 5.2448 19.7753 5.2448 19.7753L5.62827 22.4724C5.68727 22.7656 5.95275 23.0001 6.24773 23.0001H8.31261C8.66658 23.0001 8.93207 22.7362 8.93207 22.3844C8.93207 21.9154 8.99106 21.2118 9.28604 20.4203C12.9438 21.1238 17.3095 20.4203 17.3095 20.4203L17.811 22.4431C17.8995 22.7656 18.1945 23.0001 18.519 23.0001H20.6723C21.1443 23.0001 21.4688 22.5897 21.3803 22.1499C21.2328 21.3291 21.1148 20.1271 21.4983 19.658C23.3862 18.9545 26.395 15.4952 27.5454 15.8763C29.7873 16.5505 30.6132 14.6157 29.5218 12.9153ZM27.1324 13.5017C26.7785 13.5017 26.513 13.2378 26.513 12.886C26.513 12.5342 26.7785 12.2704 27.1324 12.2704C27.4864 12.2704 27.7519 12.5342 27.7519 12.886C27.7519 13.2378 27.4569 13.5017 27.1324 13.5017Z"
            />
        </svg>

        <p *ngIf="canShowTime" class="text text--color-primary fee__gas">
            ~ {{ hwTimeSec.GetTimeSecLocalized(feeOracle?.safe.time) }}
        </p>
        <p
            class="text text--extra-bold text--size-l text--size-s fee_selector-entry"
            *ngIf="!hideGwei"
        >
            {{ feeOracle?.safe.amount }}
            {{ symbol }}
        </p>
        <p class="text text--color-secondary text--size-s font-roboto-mono">
            {{ feeOracle?.safe.coinAmount | number : ".0-7" }} {{ baseUnit }}
        </p>
    </button>
    <button
        class="btn btn__fee"
        [class.btn__fee--active]="selectedFee === 'propose'"
        (click)="changeFee('propose')"
    >
        <svg
            class="icon__fee"
            viewBox="0 0 32 32"
            fill="var(--icon-color)"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M24.1714 14H23.7L20.4949 9.75063C20.3182 9.51643 20.0941 9.32738 19.8392 9.19745C19.5843 9.06752 19.3051 9.00004 19.0223 9H9.57669C8.80561 9 8.11231 9.49781 7.82592 10.2572L6.41429 14.0706C5.60225 14.2938 5 15.0691 5 16V19.5C5 19.7763 5.21096 20 5.47143 20H6.88571C6.88571 21.6569 8.15209 23 9.71429 23C11.2765 23 12.5429 21.6569 12.5429 20H19.4571C19.4571 21.6569 20.7235 23 22.2857 23C23.8479 23 25.1143 21.6569 25.1143 20H26.5286C26.789 20 27 19.7763 27 19.5V17C27 15.3431 25.7336 14 24.1714 14ZM9.71429 21.5C8.93437 21.5 8.3 20.8272 8.3 20C8.3 19.1728 8.93437 18.5 9.71429 18.5C10.4942 18.5 11.1286 19.1728 11.1286 20C11.1286 20.8272 10.4942 21.5 9.71429 21.5ZM14.9786 14H8.44526L9.57669 11H14.9786V14ZM16.3929 14V11H19.0223L21.2851 14H16.3929ZM22.2857 21.5C21.5058 21.5 20.8714 20.8272 20.8714 20C20.8714 19.1728 21.5058 18.5 22.2857 18.5C23.0656 18.5 23.7 19.1728 23.7 20C23.7 20.8272 23.0656 21.5 22.2857 21.5Z"
            />
        </svg>
        <p *ngIf="canShowTime" class="text text--color-primary fee__gas">
            ~ {{ hwTimeSec.GetTimeSecLocalized(feeOracle?.propose.time) }}
        </p>
        <p
            class="text text--extra-bold text--size-l text--size-s fee_selector-entry"
            *ngIf="!hideGwei"
        >
            {{ feeOracle?.propose.amount }}
            {{ symbol }}
        </p>
        <p class="text text--color-secondary text--size-s font-roboto-mono">
            {{ feeOracle?.propose.coinAmount | number : ".0-7" }} {{ baseUnit }}
        </p>
    </button>
    <button
        class="btn btn__fee"
        [class.btn__fee--active]="
            selectedFee !== undefined && selectedFee === 'fast'
        "
        (click)="changeFee('fast')"
    >
        <svg
            class="icon__fee"
            viewBox="0 0 32 32"
            fill="var(--icon-color)"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M11.7143 6L14.2857 14.6111L7.42857 14.8889L6 12.6667H4L4.85714 16L4 19.3333H6L7.42857 17.1111L14.2857 17.3889L11.7143 26H14.2857L19.7143 17.6667L25.4286 17.9444C26.5541 17.9444 28 17.0387 28 16C28 14.9613 26.5541 14.0556 25.4286 14.0556L19.7143 14.3333L14.2857 6H11.7143Z"
            />
        </svg>
        <p *ngIf="canShowTime" class="text text--color-primary fee__gas">
            ~ {{ hwTimeSec.GetTimeSecLocalized(feeOracle?.fast.time) }}
        </p>
        <p
            class="text text--extra-bold text--size-l text--size-s fee_selector-entry"
            *ngIf="!hideGwei"
        >
            {{ feeOracle?.fast.amount }}
            {{ symbol }}
        </p>
        <p class="text text--color-secondary text--size-s font-roboto-mono">
            {{ feeOracle?.fast.coinAmount | number : ".0-7" }} {{ baseUnit }}
        </p>
    </button>
</div>

<button
    class="btn btn__custom mt-16 mb-16 btn--round"
    [class.btn__fee--active]="selectedFee === 'custom'"
    (click)="viewCustomFee()"
    *ngIf="customFee"
>
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
        <path
            d="M13.7129 7.28529L13.776 7.56905L14.0139 7.73615L15.1592 8.54079L14.6609 10.7808L13.3042 10.9929L13.0106 11.0388L12.8281 11.2735L12.122 12.1813L11.9456 12.4082L11.9659 12.6949L12.0672 14.1193L10.0884 15.0959L9.08575 14.143L8.86862 13.9366H8.56907H7.4312H7.13169L6.91457 14.1429L5.91151 15.0961L3.9328 14.1207L4.03406 12.6957L4.05442 12.4091L3.87807 12.1823L3.17202 11.274L2.98959 11.0393L2.69591 10.9933L1.33917 10.7809L0.840831 8.54084L1.98612 7.73624L2.22396 7.56914L2.28708 7.28541L2.53837 6.15578L2.60056 5.87622L2.46059 5.62636L1.7646 4.384L3.14925 2.6032L4.4514 3.01274L4.73805 3.1029L5.00766 2.97018L6.0315 2.46618L6.29458 2.33668L6.40006 2.06308L6.90629 0.75H9.09372L9.59991 2.06304L9.70557 2.33713L9.96928 2.46655L10.9931 2.96903L11.2623 3.10111L11.5483 3.01128L12.8505 2.60227L14.2354 4.38362L13.5394 5.62623L13.3994 5.87606L13.4616 6.15559L13.7129 7.28529Z"
            stroke="var(--bg-color)" stroke-width="1.5" />
        <path
            d="M5.5 8C5.5 6.62176 6.62164 5.5 7.99943 5.5C9.37795 5.5 10.5 6.62195 10.5 8C10.5 9.37814 9.37814 10.5 8 10.5C6.62186 10.5 5.5 9.37814 5.5 8Z"
            stroke="var(--bg-color)" />
    </svg>

    <p>Custom Fee</p>
</button>
